<template>
  <PreLoader />
  <div class="d-flex gap-6">
    <AppSidebar :isMenuOpenProp="isMenuOpen" />
    <div class="main-content w-100">
      <!-- <TopHeader /> -->
      <!-- <BottomHeader /> -->

      <div class="container" style="position: relative;">
        <div class="menu-icon" @click="isMenuOpen = !isMenuOpen">
          <MenuIcon />
        </div>
      </div>

      <router-view></router-view>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import PreLoader from "./components/PreLoader.vue";
import AppSidebar from "./components/AppSidebar.vue";
import AppFooter from "./components/AppFooter.vue";
// import BottomHeader from './components/BottomHeader.vue';
// import TopHeader from './components/TopHeader.vue';
import MenuIcon from "./components/MenuIcon.vue";
export default {
  name: "App",

  components: {
    PreLoader,
    AppSidebar,
    AppFooter,
    // BottomHeader,
    // TopHeader
    MenuIcon,
  },

  data() {
    return {
      isMenuOpen: false,
    };
  },
};
</script>
